<template>
	<div class="page-container">
		<!-- 1. 合作伙伴模块 (保留原有的斜体无缝滚动) -->
		<div class="partners-section">
			<div class="container">
				<div class="partners-header">
					<div class="partners-title">合作伙伴</div>
				</div>

				<div class="marquee-container">
					<div class="marquee-row" v-for="(list, idx) in [partnerList, partnerList2, partnerList3]"
						:key="idx">
						<div class="marquee-content"
							:style="{ animation: `${idx % 2 === 0 ? 'scrollLeft' : 'scrollRight'} ${200 + idx}s linear infinite` }">
							<!-- 列表复制一份实现无缝滚动 -->
							<div v-for="(p, pIdx) in [...list, ...list]" :key="p.id + '-' + idx + '-' + pIdx"
								class="partner-card">
								<div class="partner-inner">
									<div class="logo-wrapper">
										<img :src="p.image" :alt="p.name" class="partner-img">
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 2. 合作品牌模块 (修改为静态网格，每行6个，图片全显) -->
		<div class="partners-section brands-section">
			<div class="container">
				<div class="partners-header">
					<div class="partners-title">合作品牌</div>
				</div>

				<!-- 使用 CSS Grid 布局替代滚动容器 -->
				<div class="brand-grid">
					<div v-for="b in brandList" :key="b.id" class="rect-card">
						<div class="rect-inner">
							<div class="logo-wrapper">
								<img :src="b.image" :alt="b.name" class="partner-img">
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { findBrand, findPartner } from "@/apis/api";

const brandList = ref([]);
const partnerList = ref([]);
const partnerList2 = ref([]);
const partnerList3 = ref([]);

const getFindBrand = async () => {
	try {
		const res = await findBrand();
		const data = res.data || [];
		brandList.value = data; // 静态展示

	} catch (error) {
		console.error("获取品牌数据失败:", error);
	}
};
const getPartner = async () => {
	try {
		const res = await findPartner()
		const data = res.data || [];

		partnerList.value = data;
		partnerList2.value = [...data].reverse();
		partnerList3.value = [...data].sort(() => Math.random() - 0.5);
	} catch (error) {
		console.error("获取品牌数据失败:", error);
	}
};

onMounted(() => {
	getFindBrand();
	getPartner()
});
</script>

<style>
/* 全局动画定义 */
@keyframes scrollLeft {
	0% {
		transform: translateX(0);
	}

	100% {
		transform: translateX(-50%);
	}
}

@keyframes scrollRight {
	0% {
		transform: translateX(-50%);
	}

	100% {
		transform: translateX(0);
	}
}
</style>

<style scoped>
/* 基础容器 */
.container {
	margin: 0 auto;
	padding: 0 15px;
}

.partners-section {
	margin-top: 30px;
	padding: 20px 0;
	background: transparent;
}

.partners-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 25px;
}

.partners-title {
	font-size: 24px;
	font-weight: 800;
	color: #333;
	position: relative;
	padding-left: 15px;
}

.partners-title::before {
	content: '';
	position: absolute;
	left: 0;
	top: 4px;
	height: 20px;
	width: 4px;
	background: #0066cc;
	/* 假设的科技蓝 */
	border-radius: 2px;
}

/* --- 滚动区域样式 (合作伙伴) --- */
.marquee-container {
	display: flex;
	flex-direction: column;
	gap: 15px;
	transform: skewX(-10deg);
	/* 整体倾斜 */
	padding: 10px 0;
}

.marquee-row {
	display: flex;
	overflow: hidden;
	width: 100%;
	mask-image: linear-gradient(to right, transparent, black 5%, black 95%, transparent);
	-webkit-mask-image: linear-gradient(to right, transparent, black 5%, black 95%, transparent);
}

.marquee-content {
	display: flex;
	gap: 20px;
	flex-shrink: 0;
}

.partner-card {
	width: 220px;
	height: 100px;
	background: #fff;
	border-radius: 8px;
	display: flex;
	justify-content: center;
	align-items: center;
	box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
	transform: skewX(-5deg);
	/* 卡片微调 */
	border: 1px solid #eee;
	transition: all 0.3s;
}

.partner-inner {
	transform: skewX(15deg);
	/* 文字和Logo反向倾斜校正 */
	text-align: center;
	width: 100%;
}

/* --- 网格区域样式 (合作品牌) --- */
.brands-section {
	border-top: 1px solid #f0f0f0;
	margin-top: 40px;
}

.brand-grid {
	display: grid;
	/* 核心：每行6个，平分宽度 */
	grid-template-columns: repeat(7, 1fr);
	gap: 20px;
	transform: none;
	/* 移除倾斜 */
}

.rect-card {
	background: #fff;
	border: 1px solid #efefef;
	border-radius: 8px;
	height: 100px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	transition: all 0.3s ease;
	padding: 10px;
}

.rect-card:hover {
	border-color: #0066cc;
	box-shadow: 0 5px 15px rgba(0, 102, 204, 0.1);
	transform: translateY(-3px);
}

.rect-inner {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
}

/* --- 公共图片处理 --- */
.logo-wrapper {
	width: 100%;
	height: 90px;
	/* 固定高度容器 */
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 5px;
}

.partner-img {
	width: 100%;
	height: 100%;
	/* 关键：保证图片内容完整，不剪切，保持比例 */
	object-fit: contain;
	display: block;
}

.p-name {
	font-size: 12px;
	color: #999;
	text-align: center;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	width: 100%;
}

/* --- 响应式适配 --- */
@media (max-width: 100vw) {
	.brand-grid {
		grid-template-columns: repeat(6, 1fr);
		/* 屏幕中等时每行4个 */
	}
}

@media (max-width: 768px) {
	.marquee-container {
		transform: none;
	}

	.partner-card {
		transform: none;
		width: 140px;
	}

	.partner-inner {
		transform: none;
	}

	.brand-grid {
		grid-template-columns: repeat(3, 1fr);
		/* 平板每行3个 */
		gap: 10px;
	}
}

@media (max-width: 480px) {
	.brand-grid {
		grid-template-columns: repeat(2, 1fr);
		/* 手机每行2个 */
	}

	.rect-card {
		height: 80px;
	}
}
</style>